/* projects/speaker-platform/src/app/molecules/main-menu/main-menu.component.scss */
.mainmenu__list {
  padding: 0;
  list-style: none;
}
/*# sourceMappingURL=main-menu.component-ZY2OTXY5.css.map */
